import moment from "moment";

const pStyle = { fontSize: 11, margin: 2 };

export default function ReceiptPage({
	customerName = "",
	customerPhone = "",
	branchName,
	deposit = 0,
	products = [],
	dueDate = "2021-01-01",
	discountPercent,
	totalFee,
	startDate
}: {
	customerName?: string;
	customerPhone?: string;
	deposit?: number;
	products?: { name: string; price: number; quantity?: number }[];
	dueDate?: string;
	discountPercent: number;
	totalFee: number;
	startDate?: string;
	branchName?: string;
}) {
	const totalPrice = products?.reduce(
		(acc, p) => acc + +p.price * (p.quantity || 1),
		0
	);

	return (
		<html lang="en">
			<head>
				<meta charSet="UTF-8" />
				<meta http-equiv="X-UA-Compatible" content="IE=edge" />
				<meta name="viewport" content="width=device-width, initial-scale=1.0" />
				<style
					dangerouslySetInnerHTML={{
						__html: `
						@media print and (width: 57mm) and (height: 80mm) {
							@page {
								margin: 5mm;
							}
						}`
					}}
				/>

				<title>In Bill | Tiệm Thanh Xuân</title>
			</head>

			<body style={{ margin: 0 }}>
				<div
				// style={{
				// 	display: "flex",
				// 	justifyContent: "space-between",
				// 	alignItems: "center"
				// }}
				>
					<div style={{ textAlign: "center" }}>
						<img
							// style={{ maxWidth: "100%", height: "auto" }}
							style={{ height: 80 }}
							src="/asset/img/thanhXuanLogo.jpg"
							alt="Tiệm thanh xuân"
						/>
					</div>
					{/* <div>
						<p style={pStyle}>
							<b>Find Us</b>
						</p>
						<div>
							<img
								src="https://toppng.com/uploads/preview/web-png-jpg-transparent-stock-website-icon-blue-11563644926reanjnmk6x.png"
								alt="Facebook Logo"
								style={{ maxWidth: 20, maxHeight: 20 }}
							/>
							<span style={{ marginLeft: 8, ...pStyle }}>
								tiemthanhxuan.com
							</span>
						</div>
						<div>
							<img
								src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Facebook_icon_2013.svg/1024px-Facebook_icon_2013.svg.png"
								alt="Facebook Logo"
								style={{ maxWidth: 20, maxHeight: 20 }}
							/>
							<span style={{ marginLeft: 8, ...pStyle }}>
								tiemthanhxuanchothuevay
							</span>
						</div>
					</div> */}
				</div>

				<h2 style={{ textAlign: "center", fontSize: 12 }}>
					HÓA ĐƠN THANH TOÁN
				</h2>

				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<div>
						<p style={pStyle}>Thời gian:</p>
						<p style={pStyle}>Chi nhánh:</p>
						<p style={pStyle}>Khách hàng:</p>
						<p style={pStyle}>Số điện thoại:</p>
						<p style={pStyle}>Đã cọc:</p>
						<p style={pStyle}>Ngày lấy:</p>
						<p style={pStyle}>Ngày hẹn trả:</p>
					</div>
					<div style={{ textAlign: "right" }}>
						<p style={pStyle}>
							{moment(new Date()).format("DD/MM/YYYY HH:mm")}
						</p>
						<p style={pStyle}>{branchName}</p>
						<p style={pStyle}>{customerName}</p>
						<p style={pStyle}>{customerPhone}</p>
						<p style={pStyle}>{deposit}</p>
						<p style={pStyle}>{moment(startDate).format("DD/MM/YYYY")}</p>
						<p style={pStyle}>{moment(dueDate).format("DD/MM/YYYY")}</p>
					</div>
				</div>
				<p style={pStyle}>--</p>
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<div>
						<p style={pStyle}>
							<b>Sản phẩm</b>
						</p>
						{products.map((p) => (
							<p style={pStyle} key={Math.random()}>
								{p.quantity || 1} x {p.name}
							</p>
						))}
						-<p style={pStyle}>Tổng cộng</p>
						{discountPercent && <p style={pStyle}>Chiết khấu</p>}
						<p style={pStyle}>
							<b>Thành tiền</b>
						</p>
					</div>
					<div style={{ textAlign: "right" }}>
						<p style={pStyle}>
							<b>Đơn giá</b>
						</p>
						{products.map((p) => (
							<p style={pStyle} key={Math.random()}>
								{+p.price * (p.quantity || 1)}
							</p>
						))}
						-<p style={pStyle}>{totalPrice}</p>
						{discountPercent && (
							<p style={pStyle}>
								(-{discountPercent * 100}%) | -{totalFee * discountPercent}
							</p>
						)}
						<p style={pStyle}>
							<b>{totalFee}</b>
						</p>
					</div>
				</div>
				<hr style={{ width: "60%" }} />
				<p style={{ textAlign: "center", ...pStyle }}>
					<i>Đơn đã chốt, Tiệm không nhận đổi trả</i>
				</p>
				<p style={{ textAlign: "center", ...pStyle }}>
					<i>Lấy đồ và trả đồ từ 10 giờ sáng đến 9g30 tối giúp Tiệm nhé!</i>
				</p>
				<script>setTimeout(window.print, 1000)</script>
			</body>
		</html>
	);
}
